export default "__VITE_ASSET__BlqF3EH4__"